export default __webpack_public_path__ + "static/media/pending-file-spinner.57775c43.svg";